import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Toastr from 'toastr2'

const toastr = new Toastr()

// create an axios instance
const serviceIO = axios.create({
  baseURL: process.env.APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
serviceIO.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-Token'] = getToken()
    }
    store.dispatch("app/showWaiting")
    return config
  },
  error => {
    // do something with request error
    store.dispatch("app/closeWaiting")
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
serviceIO.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res
  },
  error => {
    store.dispatch("app/closeWaiting")
    toastr.warning('网络访问错误')
    return Promise.reject('网络访问错误')
  }
)

export default serviceIO



// WEBPACK FOOTER //
// ./src/utils/requestIO.js